<template>
  <div>
    <div
      v-if="appraisalList.length"
      id="appraisal-list"
      name="appraisal-list"
      class="appraisal-details"
      appear
      tag="div" />
    <div
      v-for="(appraisalItem, i) in appraisalList"
      :id="`item-${i}`"
      :key="`${appraisalItem}-${i}`"
      class="padding-top"
      :style="{ '--i': i }">
      <AppraisalItem
        :appraisal="appraisalItem"
        :pos="i" />
    </div>
  </div>
</template>

<script>
import AppraisalItem from '@/ui/views/internal/trading/AppraisalItem.vue';

export default {
  name: 'AppraisalHistoryList',
  components: { AppraisalItem },
  props: {
    appraisalList: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.padding-top {
  padding-top: 1rem;
}
</style>
